import { useEffect } from 'react';

const MainProfile = () => {
	useEffect(() => {
		document.location.href=process.env.REACT_APP_PREFIX_MAGENTO+'/customer/account';
	});
	return (<></>);
}
export default MainProfile;
